import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import React from "react";
import {
  getStorageData,
  setStorageData,
  removeStorageData,
} from "../../../framework/src/Utilities";
import { ReceiptPrinterSetting } from "../../navigationmenu/src/HeaderController.web";
import {
  navigateTo,
  CustomEnums,
  getCustomEnumName,
  HardwarePermissionStatus,
  customPermissionApiKey,
  checkForHardwarePermissonStatus,
} from "../../utilities/src/CustomBlockHelpers";
import { makeApiMessage } from "../../../components/src/common";
import { chunk, cloneDeep, flatten, toString } from "lodash";
import qzTray, { PrintArguments, PrintData, PrinterOptions } from "qz-tray";
import { KEYUTIL, KJUR, stob64, hextorstr } from "jsrsasign";
import { FormikProps } from "formik";
import FileUpdater from "../../../components/src/customComponents/FileUpdater";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { IUserContext } from "../../navigationmenu/src/PageContainerController.web";
import * as assets from "./assets";

export interface FooterData {
  id: number;
  phone_number: string;
  website: string;
  social_link: string;
  thank_you_text: string;
  thank_you_text_ar: string;
  footer_image_base64: string;
  type_name: string;
  created_at: string;
  updated_at: string;
}
export interface InvoiceRawData {
  invoice_type: string;
  company_detail: {
    registration_no: string;
    vat_number: string | null;
  };
  store_detail: {
    store_name: string;
    store_id: string | number;
    main_cr_no: string | null;
    store_cr_number: string;
    store_address_arabic: string | null;
    ar_sub_cr_number: string | number | null;
    customer_care: string | null;
    print_invoice_header?: boolean;
  };
  customer_account: {
    full_name: string;
    full_phone_number: string;
    company_name?: string;
    sub_company_name?: string;
    cost_center?: string;
    department?: string;
    department_id?: string;
    employee_id?: string;
    sub_cost_center?: string;
    organazation_name?: string;
    organazation_tax?: string;
  };
  order_created_user: {
    full_name: string;
    first_name_arabic: string;
    last_name_arabic: string;
  };
  order: {
    order_id: number;
    invoice_number: string;
    drop_date: string;
    sub_total: string;
    applied_discount: string;
    taxable_amount: string;
    tax: string;
    total: string;
    note: string | null;
    credit_used: string;
    gp_refrence_number: string;
    remaining_points: string;
    is_qitaf_payment: boolean;
    is_mokkafa_payment: boolean;
    qitaf_amount: number;
    mokafaa_amount : number;
    net_amount: string;
  };
  order_items: Array<{
    id?: number;
    total_incl_vat: string;
    vat: string;
    unit_price: string;
    quantity: number;
    service_name: string;
    product_second_name: string;
    tag_id: string;
    product_name: string;
    sub_total: string;
    product_desc: string;
    notes: string | null;
    upcharge_details: Array<{
      name: string;
      second_name: string;
      upcharge_price: string;
      upcharge_vat: string;
      upcharge_price_without_vat: string;
    }>;
    order_item_tags: Array<{
      tag_number: string;
      permanent_tag_number: string;
    }>;
    preferences: string | null;
    preferences_specifications: string | null;
    promo_item_text_en: string | null;
    promo_item_text_ar: string | null;
    is_golden_point_discount: string | null;
    item_applied_discount: string | null;
    free_wash_discount : string | null;
    is_golden_discount_applied: boolean;
    order_discount_name_en: string | null;
    order_discount_name_ar: string | null;
    IsPromotionalItem: boolean;
    is_free_wash: boolean;
    free_wash_discount_text: string | null;
  }>;
  earned_points: number | null;
  used_points: number | null;
  available_points: number | null;
  total_pieces: number;
  order_request_type: "invoice";
  item_services: {
    [key: string]: number;
  };
  qr: string | null;
  barcode_url: string;
  invoice_number_label: string;
  is_qitaf_payment:boolean;
  is_mokkafa_payment: boolean;
  qitaf_amount: number;
  mokafaa_amount : number;
  order_label_text: string;
  terms: {
    id: null;
    description: string;
    description_ar: string;
    image_base64?: string | null;
    image_ar_base64?: string | null;
  } | null;
  logo?: string | null;
  header_logo_base64?: string | null;
  footer_image_base64?: string | null;
  footer: FooterData | null;
  is_b2b_order: boolean;
  is_golden_point_discount: string | null;
    item_applied_discount: string | null;
  is_golden_discount_applied: string | null;

is_free_wash: boolean;
  free_wash_discount_text: string | null;
  promotions?: boolean;
}
export interface SalesPostedRawData {
  title: string;
  orders: {
    invoice_number: string | null;
    order_number: string | null;
    total_pieces: number;
    id: string | number | null;
  }[];
  store_name: string;
  store_id: string;
  total_orders: number;
  total_pieces: number;
  date: string;
  time: string;
  driver_name: string;
  footer: FooterData;
  logo: string | null;
  header_logo_base64?: string | null;
}

const RESUME_ON_ERRORS = true as PrintArguments | boolean;

const DEFAULT_RECEIPT_PRINTER_SETTING = {
  id: -1,
  account_id: -1,
  printer_name: null,
  printer_type: null,
  station: null,
  auto_print_receipt: false,
  auto_print_pay_on_pickup: false,
  receipt_print_new_order: false,
  receipt_print_clean_page: false,
  receipt_print_ready_page: false,
  receipt_print_delivered_page: false,
  no_of_copies: 1,
  printer_setting_type: "receipt_printer",
};

const LOADING_ID = -2;

const globalHardwareSetting = {
  qzTrayPrinter: "",
  garmentTagQzTrayPrinter: "",
};
export const globalReceiptPrinterSetting: ReceiptPrinterSetting = {
  ...DEFAULT_RECEIPT_PRINTER_SETTING,
  id: -2,
};

const RECEIPT_CHARACTERS_PER_LINE = 42;

const LOGO = {
  type: "raw",
  format: "image",
  flavor: "file",
  data: assets.logo,
  options: { language: "ESCPOS", dotDensity: "double" },
};
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  snackbarMode?: boolean;
  isGarmentTagSetting?: boolean;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  selectedStation: string;
  printers: string[];
  stations: string[];
  snackbarMessage: string;
  initialFormValue: ReceiptPrinterSetting;
  permissionStatus: HardwarePermissionStatus | null;
  loading: boolean;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class PrintController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  getSigningDataCallId = "";
  getOrderDetailCallId = "";
  verifyOutFilesCallId = "";
  updateMissingOutFilesCallId = "";
  getReceiptPrinterSettingCallId = "";
  getCashUpSummaryRawRecipt = "";
  getSalesSummaryRawRecipt = "";
  getGarmentTagSettingCallId = "";
  updateSettingCallId = "";
  shouldScanFile = Boolean(this.props.snackbarMode);
  pathsToScanFiles: string[] = [];
  verifyList: { fileName: string; filePath: string }[] = [];
  isSigned = false;

  imageInputRef = React.createRef<HTMLInputElement>();
  pdfInputRef = React.createRef<HTMLInputElement>();
  formRef = React.createRef<FormikProps<ReceiptPrinterSetting>>();
  fileUpdater: FileUpdater = FileUpdater.getInstance();
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getCustomEnumName(CustomEnums.CustomActionReducers),
      getCustomEnumName(CustomEnums.ReceiptPrinterSettingUpdated),
      getName(MessageEnum.LayoutDataMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      selectedStation: "",
      printers: [],
      stations: Array(5)
        .fill(0)
        .map((element, index) => `Station ${index + 1}`),
      snackbarMessage: "",
      initialFormValue: globalReceiptPrinterSetting,
      permissionStatus: null,
      loading: globalReceiptPrinterSetting.id === LOADING_ID,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.receiveDataFromLayout(message);
    if (
      getName(MessageEnum.SessionResponseMessage) === message.id &&
      !this.props.snackbarMode
    ) {
      const receivedData = message.getData(
        getName(MessageEnum.SessionResponseData)
      );
      if (receivedData?.printers) {
        this.setState({ printers: receivedData.printers });
      }
    }

    this.receiveGlobalReceiptPrinterSetting(message);

    if (this.props.snackbarMode) {
      this.receiveActions(message);
      this.receiveApiResponse(message);
    } else {
      this.receiveSettingsResponse(message);
    }
    // Customizable Area End
  }

  // Customizable Area Start
  receiveDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.LayoutMessageData)
      );
      if (recievedData.userContext) {
        this.handleUserChange(recievedData.userContext);
      }
    }
  };
  async componentDidMount(): Promise<void> {
    super.componentDidMount();

    const [qzTrayPrinter, garmentTagQzTrayPrinter] = await Promise.all(
      [
        configJSON.receiptPrinterStorageKey,
        configJSON.garmentTagStorageKey,
      ].map(async (storageKey) => {
        const storedData = await getStorageData(storageKey);
        return toString(storedData);
      })
    );
    Object.assign(globalHardwareSetting, {
      qzTrayPrinter,
      garmentTagQzTrayPrinter,
    });
    this.setState(
      (prev) => ({
        initialFormValue: {
          ...prev.initialFormValue,
          printer_name: this.props.isGarmentTagSetting
            ? garmentTagQzTrayPrinter
            : qzTrayPrinter,
        },
      }),
      () => {
        if (this.props.snackbarMode) {
          this.fetchCert();
        } else {
          this.requestSession();
        }
      }
    );
    if (this.props.isGarmentTagSetting)
      this.getSetting("getGarmentTagSettingCallId");
  }
  async componentWillUnmount(): Promise<void> {
    super.componentWillUnmount();
    if (qzTray.websocket.isActive() && this.props.snackbarMode) {
      await qzTray.file.stopListening();
      qzTray.websocket.disconnect();
    }
  }

  fetchCert = async () => {
    const requestMessage = makeApiMessage({
      url: configJSON.getQzTrayCertEndPoint,
      method: configJSON.httpGetMethod,
    });
    this.getSigningDataCallId = requestMessage.messageId;
    this.send(requestMessage);
  };

  setupQZTray = async (certificate?: string, privateKeyInput?: string) => {
    const message = new Message(getName(MessageEnum.SessionSaveMessage));
    try {
      if (certificate && privateKeyInput) {
        qzTray.security.setCertificatePromise((resolve: Function) => {
          resolve(certificate);
        });
        qzTray.security.setSignatureAlgorithm("SHA512");
        qzTray.security.setSignaturePromise(
          (toSign: string) => (resolve: Function, reject: Function) => {
            try {
              const privateKey = KEYUTIL.getKey(privateKeyInput);
              const signature = new KJUR.crypto.Signature({
                alg: "SHA512withRSA",
              });
              signature.init(privateKey);
              signature.updateString(toSign);
              const hexStr = signature.sign();
              resolve(stob64(hextorstr(hexStr)));
            } catch (error) {
              console.error(error);
              reject(error);
            }
          }
        );
      } else {
        this.setState({
          snackbarMessage: "error fetching QZ Tray certificate",
        });
      }
      qzTray.websocket.setClosedCallbacks([
        () => this.fileUpdater.retryToConnect(),
      ]);
      if (!qzTray.websocket.isActive()) {
        await qzTray.websocket.connect();
      }
      this.isSigned = Boolean(certificate && privateKeyInput);
      if (this.pathsToScanFiles.length) {
        this.scanFiles(this.pathsToScanFiles);
      }
      const printers = await qzTray.printers.find();
      const printerList = flatten([printers]);
      this.setState({
        printers: printerList,
      });
      message.addData(getName(MessageEnum.SessionResponseData), {
        printers: printerList,
      });
    } catch (error) {
      this.setState({ printers: [] });
      message.addData(getName(MessageEnum.SessionResponseData), {
        printers: [],
      });
      console.error(error);
    } finally {
      this.send(message);
      this.requestSession();
    }
  };

  receiveApiResponse = (message: Message) => {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.getSigningDataCallId) {
        const { certificate, decrytped_private_key } =
          responseJson?.qz_tray_key || {};

        this.setupQZTray(
          certificate,
          decrytped_private_key
        );
      }

      if (
        apiRequestCallId === this.verifyOutFilesCallId &&
        responseJson?.missing_out_files
      ) {
        this.updateMissingOutFiles(
          responseJson?.missing_out_files || []
        );
      }

      if (apiRequestCallId === this.updateMissingOutFilesCallId) {
        this.verifyList = [];
        this.fileUpdater.updateMetalProgetti();
      }
      if (apiRequestCallId === this.getCashUpSummaryRawRecipt) {
        const numOfCopies =
          globalReceiptPrinterSetting.no_of_copies || 1;

        const printData =
         
             this.generateCashUpSummaryRawReceipt(responseJson.data);

        this.printWithQzTray(
          Array(numOfCopies).fill(printData),
          globalHardwareSetting.qzTrayPrinter,
          { encoding: "IBM864" }
        );
      }

      if (apiRequestCallId === this.getSalesSummaryRawRecipt) {
        const numOfCopies =
          globalReceiptPrinterSetting.no_of_copies || 1;

        const printData =
          responseJson?.invoice_type &&
          responseJson?.invoice_type !== ""
            ? responseJson
            : this.generateSalesSummaryRawReceipt(responseJson.data);
  console.log("SALES SUMMARY PRINT DATA:", printData);
        this.printWithQzTray(
          Array(numOfCopies).fill(printData),
          globalHardwareSetting.qzTrayPrinter,
          { encoding: "IBM864" }
        );
      }

      this.fileUpdater.receiveApiResponse(apiRequestCallId);
    }
  };

  receiveSettingsResponse = (message: Message) => {
    if (
      getCustomEnumName(CustomEnums.ReceiptPrinterSettingUpdated) ===
        message.id &&
      !this.props.isGarmentTagSetting
    ) {
      this.handleGetPrinterSetting(globalReceiptPrinterSetting);
    }
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      if (
        [this.updateSettingCallId, this.getGarmentTagSettingCallId].includes(
          apiRequestCallId
        )
      ) {
        const responseJson = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );
        if (responseJson?.data) {
          if (this.updateSettingCallId === apiRequestCallId) {
            this.handleSavePrinterSelection();
          } else {
            this.handleGetPrinterSetting(responseJson.data);
          }
        } else {
          this.setState({
            loading: false,
            snackbarMessage: "unable to update printer setting",
          });
        }
      }
    }
  };

  receiveActions = async (message: Message) => {
    if (getCustomEnumName(CustomEnums.CustomActionReducers) === message.id) {
      const action = message.getData(
        getCustomEnumName(CustomEnums.CustomReducerAction)
      );
      const payload = message.getData(
        getCustomEnumName(CustomEnums.CustomReducerPayload)
      );
      switch (action) {
        case "PRINT_RECEIPT": {
          const numOfCopies = globalReceiptPrinterSetting.no_of_copies || 1;
          const printData =
            payload?.invoice_type === "plant_receipt_invoice"
              ? this.generateGarmentTagRawInvoice(payload)
              : payload?.is_b2b_order
              ? this.generateRawDeliveryNote(payload)
               : payload?.invoice_type === "is_redeem_receipt"
              ? this.generateRedeemRawInvoice(payload)
              : this.generateRawInvoice(payload);
          this.printWithQzTray(
            Array(numOfCopies).fill(printData),
            globalHardwareSetting.qzTrayPrinter,
            { encoding: "IBM864" }
          );
          break;
        }
        case "GOLDEN_POINT_PRINT_RECEIPT": {
          const numOfCopies = globalReceiptPrinterSetting.no_of_copies || 1;
          const printData =
            payload?.invoice_type && payload?.invoice_type !== ""
              ? payload
              : this.generateGoldenPointRawInvoice(payload);
          this.printWithQzTray(
            Array(numOfCopies).fill(printData),
            globalHardwareSetting.qzTrayPrinter,
            { encoding: "IBM864" }
          );
          break;
        }
        case "SALES_SUMMARY_PRINT_RECEIPT": {

          const regionId = payload?.region_id;
          const storeId = payload?.store_id;
          const startDate = payload?.start_date;
          const endDate = payload?.end_date;

          this.createRawSalesSummaryMessage(
            regionId,
            storeId,
            startDate,
            endDate
          );
          break;
        }
       case "CASHUP_PRINT": {
          const transferRequestId = payload?.transfer_request_id;
          const startDate = payload?.start_date;
          const endDate = payload?.end_date;

          this.createCashUpSalesSummaryMessage(
            transferRequestId,
            startDate,
            endDate
          );

          break;
        }

        case "PRINT_SALES_POSTED": {
          const numOfCopies = globalReceiptPrinterSetting.no_of_copies || 1;
          const printData = this.generateRawSalesPosted(payload);
          this.printWithQzTray(
            Array(numOfCopies).fill(printData),
            globalHardwareSetting.qzTrayPrinter,
            { encoding: "IBM864" }
          );
          break;
        }
        case "PRINT_FILE": {
          this.printFromFile(payload);
          break;
        }
        case "PRINT_TAGS":
          this.printTags(payload);
          break;
        case "WRITE_FILES":
          this.writeFiles(payload);
          break;
        case "SCAN_FILES": {
          this.getSetting("getReceiptPrinterSettingCallId");
          this.receiveScanAction(payload || []);
          break;
        }
        case "LOG_OUT":
          this.handleLogout();
          break;
        default:
          break;
      }
    }
  };

  generateGarmentTagRawInvoice = (orderData: InvoiceRawData) => {
    const LINE = "------------------------------\n";
    const TAG_WIDTH = 10;
    const SVC_WIDTH = 4;
    const DESC_WIDTH = 20;
    const itemsBlock = orderData.order_items
      .flatMap((item) =>
        item.order_item_tags.map((tag) => {
          const tagId = tag.permanent_tag_number || tag.tag_number;
          const productName = item.product_name || "";
          const productSecondName = item.product_second_name || "";
          const serviceName = item.service_name || "";
          const line1 =
            `${String(tagId).padEnd(TAG_WIDTH).slice(0, TAG_WIDTH)} ` +
            `${String(serviceName).padEnd(SVC_WIDTH).slice(0, SVC_WIDTH)} ` +
            `${productName.padEnd(DESC_WIDTH).slice(0, DESC_WIDTH)}\n`;
          const line2 = `${"".padEnd(
            TAG_WIDTH + SVC_WIDTH + 1
          )}${productSecondName.padEnd(DESC_WIDTH).slice(0, DESC_WIDTH)}\n`;
          return line1 + line2;
        })
      )
      .join("");
    const payload: any[] = [
      "\x1B\x40",
      // ================= HEADER LOGO =================
      "\x1B\x61\x01",
      ...(orderData.header_logo_base64
        ? [
            {
              type: "raw",
              format: "image",
              flavor: "base64",
              data: orderData.header_logo_base64,
              options: { language: "ESCPOS", dotDensity: "double" },
            },
          ]
        : []),
      "\x1B\x21\x30\x1B\x45\x01",
      "مغاسل الجبر\n",
      "\x1B\x21\x00\x1B\x45\x00",
      "Aljabr Laundry\n\n",
      "\x1B\x21\x30\x1B\x45\x01",
      `${orderData.store_detail.store_name}\n`,
      "\x1B\x21\x00\x1B\x45\x00",
      `${orderData.store_detail.store_id}\n`,
      "\x1B\x21\x30\x1B\x45\x01",
      `INV# ${orderData.order.invoice_number}\n`,
      "\x1B\x21\x00\x1B\x45\x00",
      "\n",
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: `data:image/png;base64,${orderData.barcode_url}`,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      // ================= CUSTOMER INFO =================
      "\x1B\x61\x00",
      "\n",
      `Drop Date: ${orderData.order.drop_date}\n`,
      `Customer: ${orderData.customer_account.full_name}\n`,
      `Mob: ${orderData.customer_account.full_phone_number}\n`,
      LINE,
      // ================= ITEMS HEADER =================
      "TAG ID     SVC   DESCRIPTION\n",
      LINE,
      // ================= ITEMS =================
      itemsBlock,
      LINE,
      // ================= TOTAL PIECES =================
      "\x1B\x61\x01\x1B\x45\x01",
      `Total Pieces  ${orderData.total_pieces}\n`,
      "\x1B\x45\x00\x1B\x61\x00",
      "\n\n\n",
      "\n\n",
      "\x1D\x56\x00",
    ];
    return payload;
  };

  createCashUpSalesSummaryMessage = (
    transferRequestId: any,
    startDate: string,
    endDate: string
  ) => {
    const apiMessage = makeApiMessage({
      url:
        configJSON.cashUpSummaryRawrecipt +
        `?transfer_request_id=${transferRequestId}` +
        `&start_date=${encodeURIComponent(startDate)}` +
        `&end_date=${encodeURIComponent(endDate)}`,
      method: configJSON.dashboarApiMethodType
    });

    this.getCashUpSummaryRawRecipt = apiMessage.messageId;

    this.send(apiMessage);
  };

  createRawSalesSummaryMessage = (
    regionId: any,
    storeId: any,
    startDate: string,
    endDate: string
  ) => {

    const apiMessage = makeApiMessage({
      url:
        configJSON.salesSummaryrawOrderInvoiceData +
        `?region_ids=${regionId}` +
        `&store_ids=${storeId}` +
        `&start_date=${startDate}` +
        `&end_date=${endDate}`,

      method: configJSON.dashboarApiMethodType
    });

    this.getSalesSummaryRawRecipt = apiMessage.messageId;

    this.send(apiMessage);
  };

  receiveGlobalReceiptPrinterSetting = (message: Message) => {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      if (apiRequestCallId === this.getReceiptPrinterSettingCallId) {
        const responseJson = message.getData(
          getName(MessageEnum.RestAPIResponceSuccessMessage)
        );
        const updateData: ReceiptPrinterSetting =
          responseJson?.data || DEFAULT_RECEIPT_PRINTER_SETTING;
        delete updateData.updated_at;
        delete updateData.created_at;
        delete updateData.printer_setting_type;
        Object.assign(globalReceiptPrinterSetting, updateData);
        const updateSettingMessage = new Message(
          getCustomEnumName(CustomEnums.ReceiptPrinterSettingUpdated)
        );
        this.send(updateSettingMessage);
      }
    }
  };

  handleLogout = async () => {
    Object.assign(globalReceiptPrinterSetting, {
      ...DEFAULT_RECEIPT_PRINTER_SETTING,
      id: -2,
    });
    await this.fileUpdater.stopListening();
    this.shouldScanFile = true;
  };

  receiveScanAction = (paths: string[]) => {
    if (this.isSigned && qzTray.websocket.isActive()) {
      this.scanFiles(paths);
    } else {
      this.pathsToScanFiles = paths;
    }
  };

  changePrinter = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newSelectedPrinter = toString(event.target.value);
    this.formRef.current?.setFieldValue("printer_name", newSelectedPrinter);
  };

  changeStation = (event: React.ChangeEvent<{ value: unknown }>) =>
    this.setState({ selectedStation: toString(event.target.value) });

  requestSession = () => {
    const message = new Message(getName(MessageEnum.SessionRequestMessage));
    this.send(message);
  };

  scanFiles = async (paths: string[]) => {
    if (!this.shouldScanFile) return;
    try {
      const scanResults = await Promise.all(
        paths.flatMap((path) => this.scanPath(path))
      );
      const files = scanResults.flat();
      if (files.length) {
        //Previous implementation where all the files were sent at once to the API
        this.verifyOutFiles(files);
        //Added to prevent the UI from freezing
        // for (let i = 0; i < files.length; i += 100) {
        //   const chunk = files.slice(i, i + 100);
        //   this.verifyOutFiles(chunk);

        //   // Add a small delay between chunks to let the UI breathe
        //   if (i + 100 < files.length) {
        //     await new Promise(resolve => setTimeout(resolve, 10));
        //   }
        // }
      }
      this.fileUpdater.startListening(paths);
      return files;
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      this.shouldScanFile = false;
    }
  };

  scanPath = async (path: string) => {
    try {
      const files = await qzTray.file.list(path, {
        sandbox: false,
        shared: true,
      });
      return files.map((file) => ({
        filePath: path + "\\" + file,
        fileName: file,
      }));
    } catch (error) {
      runEngine.debugLog("ERROR SCANNING FILES AT", path);
      console.error(error);
      return [];
    }
  };

  verifyOutFiles = (files: { fileName: string; filePath: string }[]) => {
    const apiMessage = makeApiMessage({
      url: configJSON.verifyOutFilesEndPoint,
      method: configJSON.httpPostMethod,
      body: JSON.stringify({
        file_names: files.map((file) => file.fileName),
      }),
    });
    this.verifyOutFilesCallId = apiMessage.messageId;
    this.verifyList = files;
    this.send(apiMessage);
  };

  updateMissingOutFiles = async (fileNames: string[]) => {
    const allData = await Promise.all(
      fileNames.map(async (fileName) => {
        try {
          const filePath = this.verifyList.find(
            (item) => item.fileName === fileName
          )?.filePath;
          if (!filePath) return null;
          const file_content = await qzTray.file.read(filePath, {
            shared: true,
            sandbox: false,
          });
          return {
            file_name: fileName,
            file_content,
          };
        } catch (error) {
          return null;
        }
      })
    );
    const postData = allData.filter(Boolean) as Array<{
      file_name: string;
      file_content: string;
    }>;
    if (postData.length) {
      const apiMessage = makeApiMessage({
        url: configJSON.updateOutFiles,
        method: configJSON.httpPostMethod,
        body: JSON.stringify({
          data: postData,
        }),
      });
      this.updateMissingOutFilesCallId = apiMessage.messageId;
      this.send(apiMessage);
    }
  };

  printWithQzTray = async (
    printData: PrintData[][] | PrintData[],
    printerName: string,
    printerOptions?: PrinterOptions
  ) => {
    runEngine.debugLog("qztray print data and config", {
      printData,
      printerName,
    });
    if (!printData.length) return;
    if (!this.state.printers.includes(printerName)) {
      return this.setState({ snackbarMessage: this.errorMessage() });
    }
    try {
      if (!qzTray.websocket.isActive()) {
        await qzTray.websocket.connect();
      }
      const config = qzTray.configs.create(printerName, printerOptions);
      await qzTray.print(
        config,
        printData as PrintData[],
        RESUME_ON_ERRORS as PrintArguments
      );
    } catch (error) {
      this.setState({
        snackbarMessage: error instanceof Error ? error.message : "Print Error",
      });
      console.error(error);
    }
  };

  printTags = (rawDatas: Array<string>) => {
    if (
      !this.state.printers.includes(
        globalHardwareSetting.garmentTagQzTrayPrinter
      )
    ) {
      return this.setState({
        snackbarMessage: this.errorMessage("Garment Tag Printer"),
      });
    }
    const printData = rawDatas.map((rawData) => [
      {
        data: rawData,
        type: "raw",
        format: "command",
        flavor: "plain",
      },
    ]) as PrintData[][];
    this.printWithQzTray(
      printData,
      globalHardwareSetting.garmentTagQzTrayPrinter
    );
  };

  printFromFile = (payload: { data: string; format: "image" | "pdf" }) => {
    const numOfCopies = globalReceiptPrinterSetting.no_of_copies || 1;
    const itemPrintData = {
      type: "pixel",
      flavor: "file",
      ...payload,
    };
    const printData = Array(numOfCopies).fill([itemPrintData]);
    this.printWithQzTray(printData, globalHardwareSetting.qzTrayPrinter, {
      colorType: "grayscale",
    });
  };

  writeFiles = async (
    payload: { file_path: string; file_content: string }[]
  ) => {
    try {
      await Promise.all(
        payload.map((fileItem) =>
          qzTray.file.write(fileItem.file_path, {
            sandbox: false,
            shared: true,
            data: fileItem.file_content,
          })
        )
      );
      this.setState({ snackbarMessage: configJSON.writeFileSuccessMsg });
    } catch (error) {
      this.setState({
        snackbarMessage: configJSON.sharedFolderConnectionError,
      });
      console.error(error);
    }
  };

  handleCloseSnackbar = () => this.setState({ snackbarMessage: "" });

  testPrintFile = (isPrintImage?: boolean) => {
    const data = isPrintImage
      ? this.imageInputRef.current?.value
      : this.pdfInputRef.current?.value;
    const printMessage = new Message(
      getCustomEnumName(CustomEnums.CustomActionReducers)
    );
    printMessage.addData(
      getCustomEnumName(CustomEnums.CustomReducerAction),
      "PRINT_FILE"
    );
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), {
      format: isPrintImage ? "image" : "pdf",
      data,
    });
    this.send(printMessage);
  };

  testPrintRaw = async (printData: Array<PrintData | string>) => {
    runEngine.debugLog("RAW DATA TEST", { printData });
    try {
      const storedPrinter = await getStorageData(
        configJSON.receiptPrinterStorageKey
      );
      const config = qzTray.configs.create(storedPrinter, {
        encoding: "IBM864",
      });
      await qzTray.print(config, printData as PrintData[]);
    } catch (error) {
      console.error(error);
    }
  };

  handleRedirect = () =>
    this.props.navigation &&
    navigateTo({ id: "", props: this.props, screenName: "AdvancedSearch" });

  handleSave = (formValues: ReceiptPrinterSetting) => {
    const printer_name = this.currentPrinterName();
    const updateValues: Partial<ReceiptPrinterSetting> = this.props
      .isGarmentTagSetting
      ? {
          id: formValues.id,
          account_id: formValues.account_id,
          printer_name,
        }
      : {
          ...formValues,
          printer_name,
        };
    this.updatePrinterSetting(updateValues);
  };

  handleSavePrinterSelection = async () => {
    const printerName = this.currentPrinterName();
    const storageKey = this.storageKey() as
      | "qzTrayPrinter"
      | "garmentTagQzTrayPrinter";
    if (printerName) {
      await setStorageData(storageKey, printerName);
      globalHardwareSetting[storageKey] = printerName;
    } else {
      await removeStorageData(storageKey);
      globalHardwareSetting[storageKey] = "";
    }
    this.setState({
      loading: false,
      snackbarMessage: configJSON.saveSettingSuccessMsg,
    });
    if (!this.props.isGarmentTagSetting) {
      this.getSetting("getReceiptPrinterSettingCallId");
    }
  };

  storageKey = () =>
    this.props.isGarmentTagSetting
      ? configJSON.garmentTagStorageKey
      : configJSON.receiptPrinterStorageKey;

  currentPrinterName = () => {
    const printer_name = toString(this.formRef.current?.values.printer_name);
    const printerName = this.state.printers.includes(printer_name)
      ? printer_name
      : "";
    return printerName;
  };

  handleUserChange = (context: IUserContext) => {
    const apiKey = customPermissionApiKey.hardwarePermission;
    const userData = context.user?.attributes.permission_groups;
    const value = checkForHardwarePermissonStatus(
      apiKey,
      userData as unknown as Array<PermissionGroupArray>
    );
    this.setState({
      permissionStatus: value,
    });
  };
  errorMessage = (printerType?: string) =>
    `Select a printer in ${
      printerType || configJSON.receiptPrinter
    } setting page to print`;

  handleGetPrinterSetting = (newPrinterSetting?: ReceiptPrinterSetting) => {
    if (!newPrinterSetting)
      return this.setState({
        loading: false,
        snackbarMessage: "unable to fetch printer setting",
      });
    const clonedPrinterSetting = cloneDeep(newPrinterSetting);
    delete clonedPrinterSetting.created_at;
    delete clonedPrinterSetting.updated_at;
    delete clonedPrinterSetting.printer_setting_type;
    this.setState({
      initialFormValue: {
        ...clonedPrinterSetting,
        printer_name: toString(this.formRef.current?.values.printer_name),
      },
      loading: false,
    });
  };

  updatePrinterSetting = (updateValues: Partial<ReceiptPrinterSetting>) => {
    this.setState({ loading: true });
    const requestMessage = makeApiMessage({
      method: configJSON.httpPutMethod,
      url: configJSON.printerSettingsApi + updateValues.id,
      body: JSON.stringify({
        data: updateValues,
      }),
    });
    this.updateSettingCallId = requestMessage.messageId;
    this.send(requestMessage);
  };

  getSetting = (
    callId: "getGarmentTagSettingCallId" | "getReceiptPrinterSettingCallId"
  ) => {
    const requestMessage = makeApiMessage({
      method: configJSON.httpGetMethod,
      url:
        callId === "getGarmentTagSettingCallId"
          ? configJSON.garmentTagSettingApi
          : configJSON.receiptPrinterSettingApi,
    });
    this[callId] = requestMessage.messageId;
    this.send(requestMessage);
  };

  getString = (codeNumber: number) => String.fromCharCode(codeNumber);

  generateRawInvoice = (orderData: InvoiceRawData) => {
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
    const { organazation_name, organazation_tax } = orderData.customer_account;

    let organizationInfo = "";

    if (organazation_name && organazation_tax) {
      organizationInfo =
        line +
        `\x1B\x45\x0D Organisation: ${organazation_name}\x1B\x45\x0A | Organisation Tax: ${organazation_tax}\n` +
        "\x1B\x61\x00" +
        line;
    }

    let customerInfo = "";
    if (
      orderData.customer_account.full_name &&
      orderData.customer_account.full_phone_number
    ) {
      customerInfo += `\x1B\x45\x0D${orderData.customer_account.full_name}\x1B\x45\x0A | Mob: ${orderData.customer_account.full_phone_number}\n`;
      customerInfo += "\x1B\x61\x00";
    }

    const receipt = [
      "\x1B\x61\x01" +
        "\x0A" +
        "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd\x1B\x21\x00\x1B\x45\x00\n" +
        `CR: ${orderData.company_detail.registration_no} | VAT: ${toString(
          orderData.company_detail.vat_number
        )}\n` +
        "فاتورة ضريبية مبسطة" +
        "\r\n\n" +
        `${orderData.order_label_text}\n\n` +
        "\x1b\x21\x38" +
        orderData.store_detail.store_name +
        "\n" +
        "\x1b\x21\x0A\x1B\x45\x0A" +
        `${orderData.store_detail.store_id}\n` +
        this.conditionalString(
          orderData.store_detail.store_address_arabic,
          `\u200e${orderData.store_detail.store_address_arabic}` + "\r\n",
          ""
        ) +
        `Tel.${orderData.store_detail.customer_care}\n` +
        `Store CR: ${orderData.store_detail.store_cr_number}\n` +
        line +
        "\n" +
        "\x1B\x21\x38" +
        `${orderData.invoice_number_label}\n` +
        "\x1b\x21\x0A\x1B\x45\x0A",
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: `data:image/png;base64,${orderData.barcode_url}`,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      `${orderData.order.invoice_number.split("").join(" ")}\n` +
        line +
        `Drop Date: ${orderData.order.drop_date}\n` +
        `Storekeeper : ${orderData.order_created_user.full_name}\n` +
        line +
        customerInfo +
        organizationInfo +
        line +
        "\u200eالإجمالي       \u200eسعر" +
        "\x0A" +
        "\u200eقبل      الخدمات الكمية الوحدة       الوصف" +
        "\n" +
        "Sub      Unit  Qty  Svc.   Description\n" +
        "Total    Price\n" +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.getRawItems(orderData.order_items) +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.conditionalString(
          orderData.order.note,
          `\x1B\x61\x02\x1B\x45\x0DOrder Notes\n` +
            `\u200e${orderData.order.note}\x1B\x45\x0A` +
            "\n\x1B\x61\x00" +
            "-- - - - - - - - - - - - - - - - - - - - -\n",
          ""
        ) +
        `${toString(orderData.order.sub_total).padEnd(
          23
        )}Sub Total | المجموع\n` +
        `${toString(orderData.order.applied_discount).padEnd(
          9
        )}Promotional Discount | خصم ترويجي\n` +
        `${toString(orderData.order.taxable_amount).padEnd(
          8
        )}Taxable Amount | الإجمالي قبل الضر\n` +
        `${toString(orderData.order.tax).padEnd(18)}VAT 15% | القيمة المضافة\n` +
        `${toString(orderData.order.total).padEnd(
          11
        )}Total Incl. VAT | الإجمالي شامل\n` +
        `${toString(orderData.order.credit_used).padEnd(
          13
        )}Used Credit | المستخدم الرصيد\n` +
        `${orderData.order.is_qitaf_payment
          ? `${String(orderData.order.qitaf_amount).padEnd(13)}Paid With Qitaf | المستخدم الرصيد\n`
          : ""}` +
        `${orderData.order.is_mokkafa_payment
          ? `${String(orderData.order.mokafaa_amount).padEnd(13)}Paid With Mokafaa | المستخدم الرصيد\n`
          : ""}` +
        `\x1B\x21\x38${toString(orderData.order.net_amount).padEnd(
          15
        )}\x1B\x21\x00\x1B\x45\x0DNet Payable\x1B\x45\x0A\n` +
        "\x1B\x61\x01\x1B\x45\x0D" +
        "\u200eمستحق الدفع صافي" +
        " \x1B\x45\x0A\n\x1B\x61\x00" +
        line +
        `\x1B\x21\x38${toString(orderData.total_pieces).padEnd(
          8
        )}\x1B\x21\x00\x1B\x45\x0DTotal Pieces | مجموع القطع\x1B\x45\x0A\n` +
        line +
        (orderData.earned_points !== null
          ? `${toString(orderData.earned_points).padEnd(
              10
            )}Earned Points | النقاط المكتسبة\n`
          : "") +
        (orderData.used_points !== null
          ? `${toString(orderData.used_points).padEnd(
              12
            )}Used Points | النقاط المستخدمة\n`
          : "") +
        (orderData.available_points !== null
          ? `${toString(orderData.available_points).padEnd(
              8
            )}Available Points | النقاط المتاحة\n`
          : "") +
        (orderData.earned_points !== null ||
        orderData.used_points !== null ||
        orderData.available_points !== null
          ? line
          : "") +
        "\n" +
        "\x1B\x61\x01",
    ];

    const headerLogo = orderData.header_logo_base64
      ? [
          "\x1B\x40" + "\x1B\x61\x01",
          {
            type: "raw",
            format: "image",
            flavor: "base64",
            data: orderData.header_logo_base64,
            options: { language: "ESCPOS", dotDensity: "double" },
          },
        ]
      : [];

    const logo = [
      ...(headerLogo.length === 0 ? ["\x1B\x40" + "\x1B\x61\x01"] : []),
      ...(orderData.logo ? [LOGO] : []),
    ];

    const payload = [
      ...headerLogo,
      ...logo,
      ...receipt,
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: orderData.qr,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      // Terms & Conditions — printed as an uploaded image when available,
      // otherwise as raw text (see getTermsPrintItems).
      ...this.getTermsPrintItems(orderData.terms),
      "\x1B\x61\x01",
      orderData.footer
        ? {
            type: "raw",
            format: "html",
            flavor: "plain",
            data: `<div style="margin: 0;padding: 0;width: 100%;box-sizing: border-box;">
          ${this.conditionalString(
            orderData.footer,
            this.dynamicFooter(
              orderData?.footer as FooterData,
              orderData?.footer_image_base64
            ),
            ""
          )}
        </div>`,
            options: {
              language: "ESCPOS",
              pageWidth: 410,
              dotDensity: "double",
            },
          }
        : "\x0A",
      "\x0A\x1D\x56\x00",
    ];
    return payload;
  };

  generateGoldenPointRawInvoice = (orderData: InvoiceRawData) => {
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
    // const { organazation_name, organazation_tax } = orderData.customer_account;
    const customerAccount = orderData?.customer_account || {};
    const companyDetail = orderData?.company_detail || {};
    const storeDetail = orderData?.store_detail || {};
    const order = orderData?.order || {};
    const orderCreatedUser = orderData?.order_created_user || {};
    const terms = orderData?.terms || {};
    const {organazation_name = "",  organazation_tax = "", full_name = "", full_phone_number = "" } = customerAccount;

    let organizationInfo = "";

    if (organazation_name && organazation_tax) {
      organizationInfo =
        line +
        `\x1B\x45\x0D Organisation: ${organazation_name}\x1B\x45\x0A | Organisation Tax: ${organazation_tax}\n` +
        "\x1B\x61\x00" +
        line;
    }

    let customerInfo = "";
    if (
      full_name &&
     full_phone_number
    ) {
      customerInfo += `\x1B\x45\x0D${orderData.customer_account.full_name}\x1B\x45\x0A | Mob: ${orderData.customer_account.full_phone_number}\n`;
      customerInfo += "\x1B\x61\x00";
    }

    const receipt = [
      "\x1B\x61\x01" +
        "\x0A" +
        "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd\x1B\x21\x00\x1B\x45\x00\n" +
        `CR: ${orderData.company_detail.registration_no} | VAT: ${toString(
          orderData.company_detail.vat_number
        )}\n` +
        "فاتورة ضريبية مبسطة" +
        "\r\n\n" +
        `${orderData.order_label_text}\n\n` +
        "\x1b\x21\x38" +
        orderData.store_detail.store_name +
        "\n" +
        "\x1b\x21\x0A\x1B\x45\x0A" +
        `${orderData.store_detail.store_id}\n` +
        this.conditionalString(
          orderData.store_detail.store_address_arabic,
          `\u200e${orderData.store_detail.store_address_arabic}` + "\r\n",
          ""
        ) +
        `Tel.${orderData.store_detail.customer_care}\n` +
        `Store CR: ${orderData.store_detail.store_cr_number}\n` +
        line +
        "\n" +
        "\x1B\x21\x38" +
        `${orderData.invoice_number_label}\n` +
        "\x1b\x21\x0A\x1B\x45\x0A",
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: `data:image/png;base64,${orderData.barcode_url}`,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      `${orderData.order.invoice_number.split("").join(" ")}\n` +
        line +
        `Drop Date: ${orderData.order.drop_date}\n` +
        `Storekeeper : ${orderData.order_created_user.full_name}\n` +
        line +
        customerInfo +
        organizationInfo +
        line +
        "\u200eالإجمالي \u200eسعر  \u200eالكمية \u200eالوصف" +
        "\x0A" +
        "\u200eقبل      \u200eالوحدة" +
        "\n" +
        "Sub      Unit  Qty   Description\n" +
        "Total    Price\n" +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.getGoldenpointRawItems(orderData.order_items) +
        "\n" +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.conditionalString(
          orderData.order.note,
          `\x1B\x61\x02\x1B\x45\x0DOrder Notes\n` +
            `\u200e${orderData.order.note}\x1B\x45\x0A` +
            "\n\x1B\x61\x00" +
            "-- - - - - - - - - - - - - - - - - - - - -\n",
          ""
        ) +
        `${toString(orderData.order.sub_total).padEnd(
          23
        )}Sub Total | المجموع\n` +
        `${toString(0.0).padEnd(28)}Discount | خصم\n` +
        `${toString(orderData.order.taxable_amount).padEnd(
          9
        )}Taxable Amount | الإجمالي قبل الضر\n` +
        `${toString(orderData.order.tax).padEnd(22)}VAT 15| القيمة المضافة\n` +
        `${toString(orderData.order.total).padEnd(27)}Total Incl. VAT\n` +
        "\x1B\x61\x02" +
        "\u200eالإجماليشامل الإجمالي" +
        " \n\x1B\x61\x00" +
        `\x1B\x21\x38${toString(orderData.order.net_amount).padEnd(
          15
        )}\x1B\x21\x00\x1B\x45\x0DNet Payable\x1B\x45\x0A\n\n` +
        "\x1B\x61\x02\x1B\x45\x0D" +
        "\u200eمستحق الدفع صافي" +
        " \x1B\x45\x0A\n\x1B\x61\x00" +
        line +
        `\x1B\x21\x38${toString(orderData.total_pieces).padEnd(
          8
        )}\x1B\x21\x00\x1B\x45\x0DTotal Pieces | مجموع القطع\x1B\x45\x0A\n` +
        line +
        (orderData.earned_points !== null
          ? `${toString(orderData.earned_points).padEnd(
              10
            )}Earned Points | النقاط المكتسبة\n`
          : "") +
        (orderData.used_points !== null
          ? `${toString(orderData.used_points).padEnd(
              12
            )}Used Points | النقاط المستخدمة\n`
          : "") +
        (orderData.available_points !== null
          ? `${toString(orderData.available_points).padEnd(
              8
            )}Available Points | النقاط المتاحة\n`
          : "") +
        (orderData.earned_points !== null ||
        orderData.used_points !== null ||
        orderData.available_points !== null
          ? line
          : "") +
        "\n" +
        "\x1B\x61\x01",
    ];

    const headerLogo = orderData.header_logo_base64
      ? [
          "\x1B\x40" + "\x1B\x61\x01",
          {
            type: "raw",
            format: "image",
            flavor: "base64",
            data: orderData.header_logo_base64,
            options: { language: "ESCPOS", dotDensity: "double" },
          },
        ]
      : [];

    const logo = [
      ...(headerLogo.length === 0 ? ["\x1B\x40" + "\x1B\x61\x01"] : []),
      ...(orderData.logo ? [LOGO] : []),
    ];

    const payload = [
      ...headerLogo,
      ...logo,
      ...receipt,
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: orderData.qr,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      // Golden-point receipt: print ONLY the uploaded Arabic terms image —
      // no English, no description text.
      ...this.getTermsPrintItems(orderData.terms, { arabicImageOnly: true }),
      "\x1B\x61\x01",
      orderData.footer
        ? {
            type: "raw",
            format: "html",
            flavor: "plain",
            data: `<div style="margin: 0;padding: 0;width: 100%;box-sizing: border-box;">
          ${this.conditionalString(
            orderData.footer,
            this.dynamicFooter(
              orderData?.footer as FooterData,
              orderData?.footer_image_base64
            ),
            ""
          )}
        </div>`,
            options: {
              language: "ESCPOS",
              pageWidth: 410,
              dotDensity: "double",
            },
          }
        : "\x0A",
      "\x0A\x1D\x56\x00",
    ];
    return payload;
  };

  generateSalesSummaryRawReceipt = (data: any) => {
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
console.log("generateSalesSummaryRawReceiptgenerateSalesSummaryRawReceipt",data)
    const formatAmount = (value: any) =>
      `SAR ${Number(value || 0).toFixed(2)}`;

      const row = (
        english: string,
        value: string,
        arabic: string
      ) => {
        const englishWidth = 18;
        const valueWidth = 11;
        const arabicWidth = 13;

        const englishText = english
          .substring(0, englishWidth)
          .padEnd(englishWidth);

        const valueText = value
          .substring(0, valueWidth)
          .padStart(valueWidth);

        const arabicText = arabic
          .substring(0, arabicWidth)
          .padStart(arabicWidth);

        return (
          englishText +
          valueText +
          arabicText +
          "\n\n\n"
        );
      };
    const receipt = [
      // Initialize printer
      "\x1B\x40",

      // Center
      "\x1B\x61\x01",

      // Reduce line spacing
      "\x1B\x33\x0C",

      "\x0A",

      // Company name
      "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd" +
        "\x1B\x21\x00\x1B\x45\x00\n",

      "\n\n",

      // Sales Summary
      "\x1B\x21\x38" +
        "Sales Summary\n" +
        "\x1B\x21\x00",

      "\n\n",

      // Store details - BOLD
      "\x1B\x45\x01" +
        `Store Name: ${data.store_name || ""}, Store ID: ${
          data.store_id || ""
        }\n\n\n` +
        `Summary: ${data.start_summary_date || ""} - ${
          data.end_summary_date || ""
        }\n\n\n` +
       `Printed: ${data.printed_date || ""} ${data.printed_time || ""}\n\n` +
        "\x1B\x45\x00",

      line,

      // Table header
     "\x1B\x45\x01" +
      "Description".padEnd(18) +
      "Value (SAR)".padStart(11) +
      "Arabic".padStart(13) +
      "\n" +
      "\x1B\x45\x00",

      line,

      row(
        "New Orders",
        String(data.new_orders ?? 0),
        "الطلبات الجديدة"
      ),

      row(
        "Pcs",
        String(data.total_pieces ?? 0),
        "عدد القطع"
      ),

      row(
        "Sales",
        formatAmount(data.sales),
        "المبيعات"
      ),

      row(
        "Advance Sales",
        formatAmount(data.advance_sales),
        "المبيعات"
      ),

      row(
        "Advance Sales Cash",
        formatAmount(data.advance_sales_cash),
        "المبيعات"
      ),

      row(
        "Advance Sales Card",
        formatAmount(data.advance_sales_card),
        "المبيعات"
      ),

      row(
        "Discount",
        formatAmount(data.discount),
        "الخصم"
      ),

      row(
        "Tax",
        formatAmount(data.tax),
        "الضريبة"
      ),

      row(
        "Revenue",
        formatAmount(data.revenue),
        "صافي الربح"
      ),

      // Payment rows
      row(
        "Paid By Cash",
        formatAmount(data.paid_by_cash),
        "دفع كاش"
      ),

      row(
        "Paid By Card",
        formatAmount(data.paid_by_card),
        "دفع بالكارت"
      ),

      row(
        "Online",
        formatAmount(data.online_paid_amount),
        "دفع اونلاين"
      ),

      row(
        "Store Pay",
        formatAmount(data.store_pay_paid_amount),
        "دفع عن طريق الفرع"
      ),

      row(
        "Credit",
        formatAmount(data.credit),
        "الرصيد"
      ),

      row(
        "Qitaf",
        formatAmount(data.qitaf),
        "قطاف"
      ),

      row(
        "Mokafaa",
        formatAmount(data.mokafaa),
        "مكافأة"
      ),

       "\n\n\n\n\n\n",

      line,

      "\n",

      "\x1B\x61\x01",

      "\x0A",

      // Cut paper
      "\x1D\x56\x00"
    ];

    return [
      ...receipt,
    ];
  };

  generateCashUpSummaryRawReceipt = (data: any) => {

    const attributes = data?.attributes || {};

    const line =
      "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";

    const formatAmount = (value: any) =>
      `${Number(value || 0).toFixed(2)}`;
   const row = (
      english: string,
      value: string,
      arabic: string
    ) => {
      const left = english
        .substring(0, 18)
        .padEnd(18);

      const amount = value
        .substring(0, 11)
        .padStart(11);

      const arabicText = arabic
        .substring(0, 13)
        .padStart(13);

      return (
        "\x1B\x33\x0C" +
        left +
        amount +
        arabicText +
        "\n\n\n"
      );
    };

    const receipt = [
      "\x1B\x40",
      "\x1B\x61\x01",

      "\x0A",

      "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd" +
        "\x1B\x21\x00\x1B\x45\x00\n",

      "\n",

      "\x1B\x21\x38" +
         "Cash Up Summary\n\n" +
        "\x1B\x21\x00",

     "\x1B\x45\x01" +
      `Store Name: ${attributes.transfer_from?.store_name || ""}, Store ID: ${
        attributes.transfer_from?.store_id || ""
      }\n` +
      "\x1B\x45\x00",

      `Date: ${
          attributes.created_at
            ? new Date(attributes.created_at).toLocaleDateString("en-GB")
            : ""
        }    Time: ${
          attributes.created_at
            ? new Date(attributes.created_at).toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
              })
            : ""
        }\n`,

      `Driver Name: ${attributes.driver?.full_name || ""}\n`,

      line,


      row(
        "Sales",
        formatAmount(attributes.sales_amount),
        "المبيعات"
      ),

      row(
        "Advance Sales Cash",
        formatAmount(attributes.cash_from_advance_sales),
        "المبيعات"
      ),

      row(
        "Advance Sales Card",
        formatAmount(attributes.advance_sales_card),
        "المبيعات"
      ),

      row(
        "Revenue",
        formatAmount(attributes.revenue_amount),
        "صافي الربح"
      ),

      row(
        "Paid By Cash",
        formatAmount(attributes.cash_from_orders),
        "دفع كاش"
      ),

      row(
        "Paid By Card",
        formatAmount(attributes.card_paid_amount),
        "دفع بالكارت"
      ),

      row(
        "Online",
        formatAmount(attributes.online_paid_amount),
        "دفع اونلاين"
      ),

      row(
        "Store Pay",
        formatAmount(attributes.store_pay_paid_amount),
        "دفع عن طريق الفرع"
      ),

      row(
        "Credit",
        formatAmount(attributes.credit_amount),
        "الرصيد"
      ),

      row(
        "Qitaf",
        formatAmount(attributes.qitaf),
        "المبيعات"
      ),

      row(
        "Mokafaa",
        formatAmount(attributes.mokafaa),
        "المبيعات"
      ),

      row(
        "Declared Cash",
        formatAmount(attributes.amount),
        "النقدية المعلنة"
      ),

      row(
        "Variance",
        formatAmount(attributes.variance_amount),
        "الباقي"
      ),

      "\n\n\n\n\n\n",

      line,

      "\n",
      "\x1B\x61\x01",
      "\x0A",
      "\x1D\x56\x00"
    ];

  

    const payload = [
      ...receipt,
    ];

    return payload;
  };
  

   generateRedeemRawInvoice = (orderData: InvoiceRawData) => {
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
    const { organazation_name, organazation_tax } = orderData.customer_account;

    let organizationInfo = "";

    if (organazation_name && organazation_tax) {
      organizationInfo =
        line +
        `\x1B\x45\x0D Organisation: ${organazation_name}\x1B\x45\x0A | Organisation Tax: ${organazation_tax}\n` +
        "\x1B\x61\x00";
    }

    let customerInfo = "";
    if (
      orderData.customer_account.full_name &&
      orderData.customer_account.full_phone_number
    ) {
      customerInfo += `\x1B\x45\x0D${orderData.customer_account.full_name}\x1B\x45\x0A | Mob: ${orderData.customer_account.full_phone_number}\n`;
      customerInfo += "\x1B\x61\x00";
    }

    const receipt = [
      "\x1B\x61\x01" +
        "\x0A" +
        "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd\x1B\x21\x00\x1B\x45\x00\n" +
        `CR: ${orderData.company_detail.registration_no} | VAT: ${toString(
          orderData.company_detail.vat_number
        )}\n` +
        "إيصال الاستبدال"+
        "\r\n\n" +
        `${orderData.order_label_text}\n\n` +
        "\x1b\x21\x38" +
        orderData.store_detail.store_name +
        "\n" +
        "\x1b\x21\x0A\x1B\x45\x0A" +
        `${orderData.store_detail.store_id}\n` +
        this.conditionalString(
          orderData.store_detail.store_address_arabic,
          `\u200e${orderData.store_detail.store_address_arabic}` + "\r\n",
          ""
        ) +
        `Tel.${orderData.store_detail.customer_care}\n` +
        `Store CR: ${orderData.store_detail.store_cr_number}\n` +
        line +
        "\n" +
        "\x1B\x21\x38" +
        `${orderData.invoice_number_label}\n` +
        "\x1b\x21\x0A\x1B\x45\x0A",
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: `data:image/png;base64,${orderData.barcode_url}`,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      `${orderData.order.invoice_number.split("").join(" ")}\n` +
        line +
        `Drop Date: ${orderData.order.drop_date}\n` +
        `Storekeeper : ${orderData.order_created_user.full_name}\n` +
        line +
        customerInfo +
        organizationInfo +
        line +
        `\x1B\x45\x00REF INV :  ${orderData.order.gp_refrence_number}\n` +
        line +
        "\u200eالإجمالي  \u200eسعر" +
        "\x0A" +
        "\u200eقبل       \u200eالوحدة \u200eالكمية \u200eالخدمات \u200eالوصف" +
        "\n" +
        "Sub       Unit  Qty  Svc. Description\n" +
        "Total     Price\n" +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.getRedeemRawItems(orderData.order_items) +
        "- - - - - - - - - - - - - - - - - - - - - \n" +
        this.conditionalString(
          orderData.order.note,
          `\x1B\x61\x02\x1B\x45\x0DOrder Notes\n` +
            `\u200e${orderData.order.note}\x1B\x45\x0A` +
            "\n\x1B\x61\x00" +
            "-- - - - - - - - - - - - - - - - - - - - -\n",
          ""
        ) +
        `${toString(orderData.order.sub_total).padEnd(
          23
        )}Sub Total | المجموع\n`  +
        `${toString(orderData.order.credit_used).padEnd(
          13
        )}Used Points | المستخدم الرصيد\n`+
        `${toString(orderData.order.remaining_points).padEnd(
          8
        )}Remaining Points | المستخدم الرصيد\n`  +
        // +
        // `\x1B\x21\x38${toString(orderData.order.net_amount).padEnd(
        //   15
        // )}\x1B\x21\x00\x1B\x45\x0DNet Payable\x1B\x45\x0A\n`
        line +
        `\x1B\x21\x38${toString(orderData.total_pieces).padEnd(
          8
        )}\x1B\x21\x00\x1B\x45\x0DTotal Pieces | مجموع القطع\x1B\x45\x0A\n` +
        line +
        "\n" +
        "\x1B\x61\x01",
    ];

    const headerLogo = orderData.header_logo_base64
      ? [
          "\x1B\x40" + "\x1B\x61\x01",
          {
            type: "raw",
            format: "image",
            flavor: "base64",
            data: orderData.header_logo_base64,
            options: { language: "ESCPOS", dotDensity: "double" },
          },
        ]
      : [];

    const logo = [
      ...(headerLogo.length === 0 ? ["\x1B\x40" + "\x1B\x61\x01"] : []),
      ...(orderData.logo ? [LOGO] : []),
    ];

    const payload = [
      ...headerLogo,
      ...logo,
      ...receipt,
      // {
      //   type: "raw",
      //   format: "image",
      //   flavor: "base64",
      //   data: orderData.qr,
      //   options: { language: "ESCPOS", dotDensity: "double" },
      // },
      // Terms & Conditions — printed as an uploaded image when available,
      // otherwise as raw text (see getTermsPrintItems).
      ...this.getTermsPrintItems(orderData.terms),
      "\x1B\x61\x01",
      orderData.footer
        ? {
            type: "raw",
            format: "html",
            flavor: "plain",
            data: `<div style="margin: 0;padding: 0;width: 100%;box-sizing: border-box;">
          ${this.conditionalString(
            orderData.footer,
            this.dynamicFooter(
              orderData?.footer as FooterData,
              orderData?.footer_image_base64
            ),
            ""
          )}
        </div>`,
            options: {
              language: "ESCPOS",
              pageWidth: 410,
              dotDensity: "double",
            },
          }
        : "\x0A",
      "\x0A\x1D\x56\x00",
    ];
    return payload;
  };

   
  getRawItems = (orderItems: InvoiceRawData["order_items"]) => {
    const widths = {
      sub_total: 9,
      unit_price: 5,
      qty: 4,
      service_short_name: 4,
      desc: 15,
      total: RECEIPT_CHARACTERS_PER_LINE
    };
    const formattedItems = orderItems.map(item => {
      const lines = [];
      // Calculate subtotal with 2 decimal points
      const subTotal = Math.round(parseFloat(item.unit_price) * item.quantity * 100) / 100;
      const maxLines = Math.max(
        Math.ceil(toString(subTotal).length / widths.sub_total),
        Math.ceil(toString(item.unit_price).length / widths.unit_price),
        Math.ceil(toString(item.quantity).length / widths.qty),
        Math.ceil(toString(item.service_name).length / widths.service_short_name),
        Math.ceil(toString(item.product_name).length / widths.desc)
      );

      for (let line = 0; line < maxLines; line++) {
        lines.push([
          this.padField(widths.sub_total, this.getChunk(widths.sub_total, line, subTotal)),
          this.padField(widths.unit_price, this.getChunk(widths.unit_price, line, item.unit_price)),
          this.padField(widths.qty, this.getChunk(widths.qty, line, item.quantity)),
          this.padField(widths.service_short_name, this.getChunk(widths.service_short_name, line, item.service_name)),
          this.getChunk(widths.desc, line, item.product_name).padStart(widths.desc),
          // this.getChunk(widths.desc, line, item.is_golden_discount_applied && item.is_golden_point_discount ? item.product_name + item.is_golden_point_discount : "").padStart(widths.desc),

        ].join(" "));
      }
      const productSecondName = this.conditionalString(
        item.product_second_name,
        "\u200e" + item.product_second_name + " \x0A",
        ""
      );
      const promoTextAr = this.conditionalString(item.IsPromotionalItem && item.promo_item_text_ar, "\u200e" + item.promo_item_text_ar + " \x0A", "")
      const promoTextEn = this.conditionalString(item.IsPromotionalItem && item.promo_item_text_en, item.promo_item_text_en + " \x0A", "")
      const goldenPointText = this.conditionalString(item.is_golden_discount_applied && item.is_golden_point_discount, "\u200e" + item.is_golden_point_discount + " \x0A", "")
      const freeWashText = this.conditionalString( item.is_free_wash && Number(item.free_wash_discount_text ?? 0) > 0,"\u200e" + (item.free_wash_discount_text ?? "") + " \x0A","");

      const notes = this.conditionalString(item.notes, ("\u200e" + item.notes + " \x0A"), "")
      const itemPreference = this.getPreferencesString(item.preferences)
      const productDesc = this.conditionalString(item.product_desc, "\u200e" + item.product_desc + " \x0A", "")
      const itemPreferenceSpecs = this.conditionalString(item.preferences_specifications, ("\u200e" + item.preferences_specifications + " \x0A"), "")
      const promotionalDiscount = item.IsPromotionalItem && (item.order_discount_name_ar || item.order_discount_name_en) ?
        `- ${subTotal} ${item.order_discount_name_ar || ''} | ${item.order_discount_name_en || ''} - ${subTotal}\x0A` : ""
      const goldenPointDiscount = item.is_golden_discount_applied &&
        (item.is_golden_point_discount) && Number(item.item_applied_discount) > 0? `- ${item.item_applied_discount} ${item.is_golden_point_discount || ""}  - ${item.item_applied_discount}\x0A`: "";
      const freeWashDiscount = item.is_free_wash &&
        (item.free_wash_discount)  ? `- ${item.free_wash_discount} ${item.free_wash_discount_text || ""}  - ${item.free_wash_discount}\x0A`: "";
      const combinedInformation = productSecondName + promoTextAr + promoTextEn + goldenPointText + freeWashText + notes + itemPreference + itemPreferenceSpecs + productDesc + promotionalDiscount + goldenPointDiscount + freeWashDiscount;
      const productInformation = this.conditionalString(combinedInformation, "\x1B\x61\x02" + combinedInformation + "\x1B\x61\x00", "")
      const upchargeDetails = this.getUpcharges(item.upcharge_details)
      lines.push(productInformation + upchargeDetails);
      return lines.join("\n");
    });
    return formattedItems.join("\n");
  }
  getGoldenpointRawItems = (orderItems: InvoiceRawData["order_items"]) => {
    const widths = {
      sub_total: 9,
      unit_price: 5,
      qty: 4,
      desc: 30,
      total: RECEIPT_CHARACTERS_PER_LINE,
    };
    const wrapText = (text: string, maxWidth: number): string[] => {
      if (!text) return [];
      const words = text.split(" ");
      const lines: string[] = [];
      let currentLine = "";

      for (const word of words) {
        if ((currentLine + " " + word).trim().length > maxWidth) {
          lines.push(currentLine.trim());
          currentLine = word;
        } else {
          currentLine += " " + word;
        }
      }

      if (currentLine.trim()) lines.push(currentLine.trim());
      return lines;
    };

    const formattedItems = orderItems.map((item) => {
      const lines: string[] = [];

     const subTotal = Number(Number(item.sub_total).toFixed(2));
      const productNameLines = wrapText(item.product_name, widths.desc);
      lines.push(
        [
          this.padField(widths.sub_total, subTotal.toFixed(2)),
          this.padField(widths.unit_price, item.unit_price),
          this.padField(widths.qty, item.quantity),
          productNameLines[0],
        ].join(" ")
      );
      for (let i = 1; i < productNameLines.length; i++) {
        lines.push(
          " ".repeat(widths.sub_total + widths.unit_price + widths.qty + 3) +
            productNameLines[i]
        );
      }
      const secondNameLines = wrapText(
        item.product_second_name || "",
        widths.desc
      );
      secondNameLines.forEach((line) =>
        lines.push(
          " ".repeat(widths.sub_total + widths.unit_price + widths.qty + 3) +
            line
        )
      );
      const descLines = wrapText(item.product_desc || "", widths.desc);
      descLines.forEach((line) =>
        lines.push(
          " ".repeat(widths.sub_total + widths.unit_price + widths.qty + 3) +
            line
        )
      );

      return lines.join("\n");
    });
    return formattedItems.join("\n\n");
  };

  getRedeemRawItems = (orderItems: InvoiceRawData["order_items"]) => {
    const widths = {
      sub_total: 9,
      unit_price: 5,
      qty: 4,
      service_short_name: 4,
      desc: 15,
      total: RECEIPT_CHARACTERS_PER_LINE
    };
    const formattedItems = orderItems.map(item => {
      const lines = [];
      const subTotal = Math.round(parseFloat(item.unit_price) * item.quantity * 100) / 100;
      const maxLines = Math.max(
        Math.ceil(toString(subTotal).length / widths.sub_total),
        Math.ceil(toString(item.unit_price).length / widths.unit_price),
        Math.ceil(toString(item.quantity).length / widths.qty),
        Math.ceil(toString(item.service_name).length / widths.service_short_name),
        Math.ceil(toString(item.product_name).length / widths.desc)
      );

      for (let line = 0; line < maxLines; line++) {
        lines.push([
          this.padField(widths.sub_total, this.getChunk(widths.sub_total, line, subTotal)),
          this.padField(widths.unit_price, this.getChunk(widths.unit_price, line, item.unit_price)),
          this.padField(widths.qty, this.getChunk(widths.qty, line, item.quantity)),
          this.padField(widths.service_short_name, this.getChunk(widths.service_short_name, line, item.service_name)),
          this.getChunk(widths.desc, line, item.product_name).padStart(widths.desc),
          // this.getChunk(widths.desc, line, item.is_golden_discount_applied && item.is_golden_point_discount ? item.product_name + item.is_golden_point_discount : "").padStart(widths.desc),
        ].join(" "));
      }
      const productSecondName = this.conditionalString(
        item.product_second_name,
        "\u200e" + item.product_second_name + " \x0A",
        ""
      );
      const freeWashText = this.conditionalString( item.is_free_wash && Number(item.free_wash_discount_text ?? 0) > 0,"\u200e" + (item.free_wash_discount_text ?? "") + " \x0A","");
      const freeWashDiscount = item.is_free_wash &&
        (item.free_wash_discount)  ? `- ${item.free_wash_discount} ${item.free_wash_discount_text || ""}  - ${item.free_wash_discount}\x0A`: "";

      const notes = this.conditionalString(item.notes, ("\u200e" + item.notes + " \x0A"), "")
      const itemPreference = this.getPreferencesString(item.preferences)
      const productDesc = this.conditionalString(item.product_desc, "\u200e" + item.product_desc + " \x0A", "")
      const itemPreferenceSpecs = this.conditionalString(item.preferences_specifications, ("\u200e" + item.preferences_specifications + " \x0A"), "")
      const combinedInformation = productSecondName  + freeWashText + notes + itemPreference + itemPreferenceSpecs + productDesc + freeWashDiscount;
      const productInformation = this.conditionalString(combinedInformation, "\x1B\x61\x02" + combinedInformation + "\x1B\x61\x00", "")
      const upchargeDetails = this.getUpcharges(item.upcharge_details)
      lines.push(productInformation + upchargeDetails);
      return lines.join("\n");
    });
    return formattedItems.join("\n");
  }

  getUpcharges = (
    upcharge_details: InvoiceRawData["order_items"][number]["upcharge_details"]
  ) => {
    if (!upcharge_details.length) return "";
    const widths = {
      upcharge_price: 9,
      upcharge_vat: 4,
      upcharge_price_without_vat: 5,
      name: 21,
    };
    const upcharge_string = upcharge_details.map((item) => {
      const lines = [];
      const maxLines = Math.max(
        Math.ceil(toString(item.upcharge_price).length / widths.upcharge_price),
        Math.ceil(toString(item.upcharge_vat).length / widths.upcharge_vat),
        Math.ceil(
          toString(item.upcharge_price_without_vat).length /
            widths.upcharge_price_without_vat
        ),
        Math.ceil(toString(item.name).length / widths.name)
      );
      for (let line = 0; line < maxLines; line++) {
        lines.push(
          [
            this.padField(
              widths.upcharge_price,
              this.getChunk(widths.upcharge_price, line, item.upcharge_price)
            ),
            this.padField(
              widths.upcharge_vat,
              this.getChunk(widths.upcharge_vat, line, item.upcharge_vat)
            ),
            this.padField(
              widths.upcharge_price_without_vat,
              this.getChunk(
                widths.upcharge_price_without_vat,
                line,
                item.upcharge_price_without_vat
              )
            ),
            this.getChunk(widths.name, line, item.name).padStart(widths.name),
          ].join(" ")
        );
      }
      let result = lines.join("\n");

      result += this.conditionalString(
        item.second_name,
        "\x0A\x1B\x61\x02\u200e" + item.second_name + " \n\x1B\x61\x00",
        "\n"
      );
      return result;
    });
    return upcharge_string.join("");
  };

  padField = (width: number, value: unknown) => {
    return toString(value).padEnd(width);
  };

  getChunk = (width: number, lineIndex: number, value: unknown) => {
    const start = lineIndex * width;
    return toString(value).substring(start, width + start);
  };

  conditionalString = (
    condition: unknown,
    valueIfTrue: string,
    valueIfFalse: string
  ) => (condition ? valueIfTrue : valueIfFalse);

  getPreferencesString = (preferencesString: string | null) => {
    if (!preferencesString) return "";
    if (preferencesString.length < RECEIPT_CHARACTERS_PER_LINE)
      return preferencesString + " \n";
    const preferences = preferencesString.split(" / ");
    let result = "";
    let currentNumOfCharacters = 0;
    let endCharacters = " \n";
    for (const preference of preferences) {
      if (preference.length >= RECEIPT_CHARACTERS_PER_LINE) {
        const chunkArrays = chunk(preference, RECEIPT_CHARACTERS_PER_LINE - 1);
        const chunks = chunkArrays.map((chunkArray) => chunkArray.join(""));
        const nextString = chunks.join(" \n");
        result =
          result +
          this.conditionalString(currentNumOfCharacters, "\n", "") +
          nextString +
          " \n";
        currentNumOfCharacters = 0;
        endCharacters = "";
      } else {
        const nextString = this.conditionalString(
          currentNumOfCharacters,
          ` / ${preference}`,
          preference
        );
        const numOfCharacters = currentNumOfCharacters + nextString.length;
        if (numOfCharacters < RECEIPT_CHARACTERS_PER_LINE) {
          result += nextString;
          currentNumOfCharacters = numOfCharacters;
        } else {
          result = result + "\n" + preference;
          currentNumOfCharacters = preference.length;
        }
      }
    }
    return result + endCharacters;
  };

  generateRawSalesPosted = (salesPostedData: SalesPostedRawData) => {
    const line = "_".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n\n";

    const headerLogo = salesPostedData.header_logo_base64
      ? [
          "\x1B\x40" + "\x1B\x61\x01",
          {
            type: "raw",
            format: "image",
            flavor: "base64",
            data: salesPostedData.header_logo_base64,
            options: { language: "ESCPOS", dotDensity: "double" },
          },
        ]
      : [];

    const printData = [
      ...headerLogo,
      ...(headerLogo.length === 0 ? ["\x1B\x40" + "\x1B\x61\x01"] : []),
      salesPostedData.logo ? LOGO : "\x0A",
      "\x0A" +
        "\x1B\x21\x30Sales Posted\x1B\x21\x00\x0A" +
        line +
        `\x1B\x45\x0DStore Name: ${salesPostedData.store_name}, Store ID: ${salesPostedData.store_id}\x1B\x45\x0A\x0A` +
        `Date: ${salesPostedData.date}, Time: ${salesPostedData.time}\n` +
        `Driver Name: ${salesPostedData.driver_name}\n` +
        line +
        "\x1B\x61\x00" +
        this.salesPostedTable(
          salesPostedData.orders.map((order) => ({
            order_number:
              toString(order.invoice_number) || toString(order.order_number),
            total_pieces: toString(order.total_pieces),
          })),
          toString(salesPostedData.total_orders),
          toString(salesPostedData.total_pieces)
        ) +
        line +
        "\x1B\x61\x01",
      salesPostedData.footer
        ? {
            type: "raw",
            format: "html",
            flavor: "plain",
            data: this.dynamicFooter(salesPostedData.footer),
            options: {
              language: "ESCPOS",
              pageWidth: 400,
              dotDensity: "double",
            },
          }
        : "\x0A",
      "\x0A\x0A" + "\x0A\x1D\x56\x00",
    ];
    return printData;
  };

  salesPostedTable = (
    items: { order_number: string; total_pieces: string }[],
    totalOrderCount: string,
    totalPiecesCount: string
  ) => {
    let output = "";
    output +=
      "\x1B\x45\x0D" +
      " ".repeat(12) +
      "Orders" +
      " ".repeat(7) +
      "Pieces" +
      "\x1B\x45\x0A\n";
    output += "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
    items.forEach((item) => {
      output += this.formatOrdersPiecesRow(
        item.order_number,
        item.total_pieces
      );
    });

    output += "_".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n\n";
    output += " ".repeat(18) + "\x1B\x45\x0DTotal\n";
    output +=
      this.formatOrdersPiecesRow(
        totalOrderCount,
        totalPiecesCount,
        true,
        "   "
      ) + "\x1B\x45\x0A";

    return output;
  };

  formatOrdersPiecesRow = (
    orderCount: string,
    piecesCount: string,
    isTotalLine?: boolean,
    divider = " | ",
    maxOrderCountLength = 20,
    maxPiecesCountLength = 19
  ) => {
    let formattedLines = "";
    const orderLines = this.chunkString(orderCount, maxOrderCountLength);
    const piecesLines = this.chunkString(piecesCount, maxPiecesCountLength);

    const maxLines = Math.max(orderLines.length, piecesLines.length);

    for (let i = 0; i < maxLines; i++) {
      const orderLine = toString(orderLines[i]);
      const piecesLine = toString(piecesLines[i]);

      const orderAligned =
        orderLines.length === 1
          ? this.centerAlign(orderLine, maxOrderCountLength, 10)
          : orderLine;
      const piecesAligned =
        piecesLines.length === 1
          ? this.centerAlign(piecesLine, maxPiecesCountLength, 10, true)
          : piecesLine;

      formattedLines +=
        orderAligned.padEnd(maxOrderCountLength) +
        divider +
        piecesAligned.padEnd(maxPiecesCountLength) +
        "\n";
    }

    if ((orderLines.length > 1 || piecesLines.length > 1) && !isTotalLine) {
      formattedLines += " ".repeat(21) + "|\n";
    }

    return formattedLines;
  };

  centerAlign = (
    text: string,
    maxLength: number,
    shiftSpaces = 0,
    shiftToLeft?: boolean
  ) => {
    const leftSpaces = shiftToLeft ? 0 : shiftSpaces;
    const rightSpaces = shiftToLeft ? shiftSpaces : 0;
    if (leftSpaces && text.length >= maxLength - leftSpaces) {
      return text.padStart(maxLength);
    }
    if (rightSpaces && text.length >= maxLength - rightSpaces) {
      return text.padEnd(maxLength);
    }
    const totalPadding = maxLength - text.length - leftSpaces - rightSpaces;
    const leftPadding = Math.floor(totalPadding / 2);
    const rightPadding = totalPadding - leftPadding;
    return (
      " ".repeat(leftPadding + leftSpaces) +
      text +
      " ".repeat(rightPadding + rightSpaces)
    );
  };

  chunkString = (inputString: string, maxLength: number) =>
    chunk(inputString, maxLength).map((chunkArray) => chunkArray.join(""));

  handleCall = () => {
    this.getString(1);
    this.currentPrinterName();
    this.storageKey();
    this.setState({
      loading: true,
    });
    this.errorMessage();
  };

  generateRawDeliveryNote = (orderData: InvoiceRawData) => {
    const { company_detail, customer_account, order, store_detail } = orderData;
    const {
      full_name,
      full_phone_number,
      employee_id = "",
      department = "",
      department_id = "",
      company_name = "",
      sub_company_name = "",
      cost_center = "",
      sub_cost_center = "",
    } = customer_account;
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";

    const headerLogo = orderData.header_logo_base64
      ? [
          "\x1B\x40" + "\x1B\x61\x01",
          {
            type: "raw",
            format: "image",
            flavor: "base64",
            data: orderData.header_logo_base64,
            options: { language: "ESCPOS", dotDensity: "double" },
          },
        ]
      : [];

    const logo = [
      ...(headerLogo.length === 0 ? ["\x1B\x40" + "\x1B\x61\x01"] : []),
      ...(orderData.logo ? [LOGO] : []),
    ];

    let departmentInfo = "";
    if (department) {
      departmentInfo += `{DEPT: ${department}}`;
      if (department_id) {
        departmentInfo += ` | DEPT ID: ${department_id}`;
      }
      departmentInfo += "\n";
    }

    let costCenterInfo = "";
    if (cost_center) {
      costCenterInfo += `COST CENTER: ${cost_center}\n`;
      if (sub_cost_center) {
        costCenterInfo += `SUB COST CENTER: ${sub_cost_center}\n`;
      }
    }
    const payload = [
      ...headerLogo,
      ...logo,
      "\x1B\x74\x25" +
        "\x1B\x21\x10\x1B\x45\x01" +
        "شركة مغاسل الجبر المحدودة" +
        "\n" +
        "\x1B\x00" +
        "Aljabrlaundries Co Ltd\x1B\x21\x00\x1B\x45\x00\n" +
        "\u200eملحوظة \u200eالتسليم" +
        "\r\n" +
        `${orderData.order_label_text}\n` +
        "\x1B\x21\x38" +
        `${store_detail.store_name}\n` +
        "\x1b\x21\x0A\x1B\x45\x0A" +
        `${store_detail.store_id} | Tel.${store_detail.customer_care}\n` +
        `CR: ${company_detail.registration_no} | VAT: ${toString(
          company_detail.vat_number
        )}\n` +
        line +
        "\x1B\x21\x38" +
        `${orderData.invoice_number_label}\n` +
        "\x1b\x21\x0A\x1B\x45\x0A" +
        line,
      {
        type: "raw",
        format: "image",
        flavor: "base64",
        data: `data:image/png;base64,${orderData.barcode_url}`,
        options: { language: "ESCPOS", dotDensity: "double" },
      },
      `${orderData.order.invoice_number.split("").join(" ")}\n` +
        line +
        "\n" +
        `Drop Date: ${order.drop_date}\n` +
        `Storekeeper: ${orderData.order_created_user.full_name}\n` +
        line +
        `\x1B\x45\x0D${full_name}\x1B\x45\x0A | Mob: ${full_phone_number}\n` +
        `\x1B\x45\x0DCompany Name: ${company_name}\x1B\x45\x0A | Sub-Company Name: ${sub_company_name}\n` +
        departmentInfo +
        costCenterInfo +
        `EM ID: ${employee_id}\n` +
        line,
      this.getDeliveryNoteTable(orderData),
      // Terms & Conditions — printed as an uploaded image when available,
      // otherwise as raw text (see getTermsPrintItems).
      ...this.getTermsPrintItems(orderData.terms),
      "\x1B\x61\x01",
      orderData.footer
        ? {
            type: "raw",
            format: "html",
            flavor: "plain",
            data: `<div style="margin: 0;padding: 0;width: 100%;box-sizing: border-box;">
          ${this.conditionalString(
            orderData.footer,
            this.dynamicFooter(
              orderData?.footer as FooterData,
              orderData?.footer_image_base64
            ),
            ""
          )}
        </div>`,
            options: {
              language: "ESCPOS",
              pageWidth: 410,
              dotDensity: "double",
            },
          }
        : "\x0A",
      "\x0A\x1D\x56\x00",
    ];
    return payload;
  };

  getDeliveryNoteTable = (orderData: InvoiceRawData) => {
    const { order_items, order, total_pieces = 0 } = orderData;
    const line =
      "- ".repeat(Math.floor(RECEIPT_CHARACTERS_PER_LINE / 2)) + "\n";
    const widths = {
      qty: 5,
      service_short_name: 7,
      desc: 28,
      total: RECEIPT_CHARACTERS_PER_LINE,
    };
    const formattedItems = order_items.map((item) => {
      const lines: string[] = [];
      const maxLines = Math.max(
        Math.ceil(toString(item.quantity).length / widths.qty),
        Math.ceil(
          toString(item.service_name).length / widths.service_short_name
        ),
        Math.ceil(toString(item.product_name).length / widths.desc)
      );

      for (let line = 0; line < maxLines; line++) {
        lines.push(
          [
            this.padField(
              widths.qty,
              this.getChunk(widths.qty, line, item.quantity)
            ),
            this.padField(
              widths.service_short_name,
              this.getChunk(widths.service_short_name, line, item.service_name)
            ),
            this.getChunk(widths.desc, line, item.product_name).padStart(
              widths.desc
            ),
          ].join(" ")
        );
      }
      const productSecondName = this.conditionalString(
        item.product_second_name,
        `\u200e${item.product_second_name}\x0A`,
        ""
      );
      const notes = this.conditionalString(
        item.notes,
        `Note: ${item.notes}\x0A`,
        ""
      );
      const productDesc = this.conditionalString(
        item.product_desc,
        "\u200e" + item.product_desc + "\x0A",
        ""
      );
      const itemPreference = this.conditionalString(
        item.preferences,
        "\u200e" + item.preferences + "\x0A",
        ""
      );
      const itemPreferenceSpecs = this.conditionalString(
        item.preferences_specifications,
        "\u200e" + item.preferences_specifications + "\x0A",
        ""
      );
      const upchargeDetails = this.conditionalString(
        item.upcharge_details.length,
        item.upcharge_details
          .map(
            (upcharge_detail) =>
              upcharge_detail.name +
              (upcharge_detail.second_name
                ? `\x0A\u200e${upcharge_detail.second_name}`
                : "")
          )
          .join("\x0A") + "\x0A",
        ""
      );
      const combinedInformation =
        productSecondName +
        productDesc +
        itemPreference +
        itemPreferenceSpecs +
        upchargeDetails +
        notes;
      lines.push(combinedInformation);
      const result = lines.join("\n");
      return result;
    });
    return (
      "\x1B\x61\x02" +
      "\u200eالكمية   الخدمات                        الوصــــف" +
      "\x0A" +
      `Qty${" ".repeat(3)}Service${" ".repeat(18)}Description\n` +
      line +
      formattedItems.join("\n") +
      "\n" +
      line +
      "\x1B\x45\x0DOrder Notes\n" +
      this.conditionalString(order.note, order.note + "\n", "") +
      "\x1B\x45\x0A" +
      line +
      `\x1B\x21\x30${toString(total_pieces).padEnd(
        15
      )}\x1B\x21\x00\x1B\x45\x0DTotal Pieces\n` +
      "\u200eمجموع \u200eالقطع\n" +
      "\x1B\x45\x0A"
    );
  };

  // Converts (possibly HTML) terms text into plain text so it can be printed as
  // raw ESC/POS and use the printer's built-in font (same as the item table).
  stripHtmlToText = (html?: string | null) =>
    (html || "")
      .replace(/<\s*br\s*\/?>/gi, "\n")
      .replace(/<\/\s*(p|div|li|h[1-6])\s*>/gi, "\n")
      .replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/\r/g, "")
      .replace(/\n{3,}/g, "\n\n")
      .trim();

  // Word-wraps text to a fixed column width so the thermal printer never has to
  // re-wrap a long line itself. For RTL (Arabic) paragraphs the printer's own
  // wrapping scrambles the visual line order and pushes list numbers (١، ٢…) to
  // the wrong line — pre-wrapping into lines that already fit avoids that, so
  // each clause keeps its number at the start (right side).
  wrapReceiptText = (
    text?: string | null,
    maxChars: number = RECEIPT_CHARACTERS_PER_LINE
  ) =>
    (text || "")
      .split("\n")
      .map((paragraph) => {
        const words = paragraph.trim().split(/\s+/).filter(Boolean);
        if (!words.length) return "";
        const lines: string[] = [];
        let current = "";
        for (const word of words) {
          const candidate = current ? `${current} ${word}` : word;
          if (candidate.length > maxChars && current) {
            lines.push(current);
            current = word;
          } else {
            current = candidate;
          }
        }
        if (current) lines.push(current);
        return lines.join("\n");
      })
      .join("\n");

  // Builds the Terms & Conditions print items. The backend may deliver terms as
  // an uploaded image (image_base64 / image_ar_base64) or as text (description /
  // description_ar). Images are preferred — they sidestep the printer's IBM864
  // charset limits (e.g. Arabic tashkeel) and RTL wrapping issues — and we fall
  // back to raw text when no image was uploaded.
  getTermsPrintItems = (
    terms?: InvoiceRawData["terms"],
    options?: { arabicImageOnly?: boolean }
  ): any[] => {
    if (!terms) return [];
    const line = "-".repeat(RECEIPT_CHARACTERS_PER_LINE) + "\n";
    const imageItem = (data: string) => ({
      type: "raw",
      format: "image",
      flavor: "base64",
      data,
      options: { language: "ESCPOS", dotDensity: "double" },
    });
    const items: any[] = [];
    // Arabic-image-only mode (e.g. golden-point receipt): print only the
    // uploaded Arabic image, nothing else — no English, no text fallback.
    if (options?.arabicImageOnly) {
      if (terms.image_ar_base64) {
        items.push("\x1B\x61\x01", imageItem(terms.image_ar_base64));
      }
      return items;
    }
    // English terms — image if uploaded, otherwise raw text (left-aligned).
    if (terms.image_base64) {
      items.push("\x1B\x61\x01", imageItem(terms.image_base64));
    } else if (terms.description) {
      items.push(
        "\x1B\x61\x00",
        line +
          "Terms & Conditions\n" +
          `${this.stripHtmlToText(terms.description)}\n` +
          line
      );
    }
    // Arabic terms — image if uploaded, otherwise raw text (right-aligned and
    // pre-wrapped so the printer doesn't scramble the RTL line order).
    if (terms.image_ar_base64) {
      items.push("\x1B\x61\x01", imageItem(terms.image_ar_base64));
    } else if (terms.description_ar) {
      items.push(
        "\x1B\x61\x02",
        line +
          "الشروط والأحكام\n" +
          `${this.wrapReceiptText(
            this.stripHtmlToText(terms.description_ar)
          )}\n` +
          line +
          "\x1B\x61\x00"
      );
    }
    return items;
  };

  dynamicFooter = (
    footerData: FooterData,
    externalFooterImage?: string | null
  ) => {
    const { footer_image_base64 } = footerData || {};
    // Use external image if provided (for B2B), otherwise use image from footer object
    const imageToDisplay = externalFooterImage || footer_image_base64;
    console.log("Footer data:", footerData);
    console.log("External footer image:", externalFooterImage);
    console.log("Footer image to display:", imageToDisplay);
    return `<div style="text-align: center;font-size: 13px;">
        ${
          imageToDisplay
            ? `<img src="${imageToDisplay}" style="margin: 10px auto; max-width: 100%; display: block;" />`
            : ""
        }
      </div>
      `; // Customizable Area End
  };
}
